const STICKY_SELECTOR = 'product-form-button.product-form__sticky-buy-button';
const RERENDER_EVENT = 'pdp:section-rerendered';

class StickyBuySync extends HTMLElement {
  connectedCallback() {
    this.root = document.getElementById('MainContent') || document.body;
    this.observer = new MutationObserver(this.onMutations);
    this.observer.observe(this.root, { childList: true, subtree: true });
    document.addEventListener(RERENDER_EVENT, this.scheduleResync);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    document.removeEventListener(RERENDER_EVENT, this.scheduleResync);
  }

  onMutations = (records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches?.(STICKY_SELECTOR) || node.querySelector?.(STICKY_SELECTOR)) {
          this.scheduleResync();
          return;
        }
      }
    }
  };

  scheduleResync = () => {
    if (this.pending) return;
    this.pending = true;
    requestAnimationFrame(() => {
      this.pending = false;
      this.resync();
    });
  };

  resync() {
    if (!document.querySelector(STICKY_SELECTOR)) return;
    document.body.removeAttribute('is-product-form-button-fixed');
    requestAnimationFrame(() => window.dispatchEvent(new Event('scroll')));
  }
}

if (!customElements.get('sticky-buy-sync')) {
  customElements.define('sticky-buy-sync', StickyBuySync);
}
